import React from "react";
import PersonalizedSuggestions from "@/features/contacts/components/PersonalizedSuggestions";
import { EXAMPLE_SEARCH_LIMIT, PROSPECT_DISCOVER_SUGGESTIONS } from "../../constants/prospectConfig";

/** Suggested searches for people, written from the user's company (defaults if none yet). */
export default function ExampleSearches({ onPick }: { onPick: (query: string) => void }) {
  return (
    <PersonalizedSuggestions
      kind="contacts"
      fallback={PROSPECT_DISCOVER_SUGGESTIONS}
      limit={EXAMPLE_SEARCH_LIMIT}
      onPick={onPick}
    />
  );
}
